import { useMemo, useState } from "react";
import { editorPicks, dailyPicks, hiddenGems, monthlyHot, privateCollection, categories } from "@/mocks/comics";
import ComicCard from "./ComicCard";
import SectionHeader from "./SectionHeader";

const allComics = [
  ...editorPicks,
  ...dailyPicks,
  ...hiddenGems,
  ...monthlyHot,
  ...privateCollection,
];

const CATEGORY_MATCH: Record<string, string[]> = {
  xianqing: ["悬疑推理", "奇幻悬疑", "武侠"],
  zhiyu: ["治愈温情", "治愈", "冷门治愈", "美食温情", "都市日常", "温情日常", "奇幻治愈", "成长治愈"],
  rexue: ["热血冒险", "热血战斗", "热血成长", "公路冒险", "武侠"],
  lianai: ["恋爱日常", "冷门恋爱", "文艺恋爱", "科幻浪漫", "青春校园", "文艺成长"],
  huanxiang: ["奇幻科幻", "东方奇幻", "奇幻悬疑", "科幻浪漫", "奇幻治愈", "奇幻温情"],
};

export default function DailyPicks() {
  const [active, setActive] = useState("all");

  const filtered = useMemo(() => {
    if (active === "all") return allComics;
    const keys = CATEGORY_MATCH[active] ?? [];
    return allComics.filter((c) => keys.some((k) => c.genre.includes(k) || c.tags.includes(k)));
  }, [active]);

  return (
    <section id="每日精选" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeader
          eyebrow="每日精选"
          eyebrowTone="accent"
          title={
            <>
              今日精选好漫 <span className="text-accent-600">· 每天不重样</span>
            </>
          }
          subtitle="按题材分类浏览全部精选作品，悬疑、治愈、热血、恋爱、奇幻，总有一款适合当下的你。"
          action={
            <div className="flex flex-wrap gap-2">
              {categories.map((cat) => (
                <button
                  key={cat.key}
                  type="button"
                  onClick={() => setActive(cat.key)}
                  className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                    active === cat.key
                      ? "bg-accent-500 text-background-50"
                      : "border border-background-300 bg-background-50 text-foreground-700 hover:border-accent-300 hover:text-accent-700"
                  }`}
                >
                  {cat.label}
                </button>
              ))}
            </div>
          }
        />

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {filtered.map((comic) => (
            <ComicCard key={comic.id} comic={comic} size="small" />
          ))}
        </div>
      </div>
    </section>
  );
}